import { userName, userID, email, avatar } from "src/utils/datalayer"
import { get } from "../http"


export const getJaaSToken = async () => {
	const response = await get(
		"https://backend.swoogo-retrofit.tkevents.io/rt/getToken",
		{avatar, email, id: userID, name: userName},
	)

	if (!response.token) {
		throw response
	} else {
		return response.token
	}
}
